import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { TrainingItemDetails } from '../../models/trainingItemDetails'
import { CourseCatalogueSearchResult } from '../../../../course-catalogue/models/course-catalogue-search-result';
import { CourseCatalogueSearchComponent } from '../../../../course-catalogue/course-catalogue-search/course-catalogue-search.component';
import { EqmsScopeManagementService } from '../../../../shared/services/eqms-scope-management.service';
import { cloneDeep } from 'lodash-es';
import { EmployeesTrainingPlanConstants } from '../../employees-training-plan.constants';
import { EmployeesTrainingPlanPersistenceService } from '../../services/employees-training-plan-persistence.service';
import { EmployeesTrainingPlanService } from '../../services/employees-training-plan.service';
import { UserTrainingPlanDTO } from '../../../../my-space/user-training-plan/models/user-training-plan';
import { SelectedUserScopesDTO } from '../../models/selectedUserScopesDTO';
import { TrainingPlanDetailsDto } from '../../../../my-space/user-training-plan/models/trainingPlanDetailsDto';
import { UserProfileConstants } from '../../../../my-space/user-profile/user-profile-constants';

@Component({
  selector: 'app-employee-training-plan-course-details',
  templateUrl: './employee-training-plan-course-details.component.html',
  styleUrls: ['./employee-training-plan-course-details.component.scss']
})
export class EmployeeTrainingPlanCourseDetailsComponent implements OnInit {
  @Output() activateTabIndex = new EventEmitter<number>();
  courseCatalogueSearchResult: CourseCatalogueSearchResult[] = []
  isTrainingPlanSaveInProgress: boolean = false;
  TrainingPlanSaveInProgressMessage : string = EmployeesTrainingPlanConstants.EmployeeTrainingPlan_SaveInProgress;
  panelListScreen : string = EmployeesTrainingPlanConstants.EmployeeTrainingPlanCourseDetails;
  errorMessages: string[] = [];  
  items: MenuItem[] = [];
  showAddButton : boolean = false;
  selectedCourses : CourseCatalogueSearchResult[] = [];
  showCheckBoxes : boolean = true;
  linkedItemDataToDisplay:any;
  @Input() userScopes: SelectedUserScopesDTO | undefined;
  @Input() userPUID: string | undefined;
  listOfselectedCourses:string[]=[];
  linkedTrainingItem : any;
  scope?:number;
  trainingItemsList : TrainingItemDetails[]=[];
  trainingItemNumbers : string[] = [];
  isUpdate: boolean = false;
  addAndClose : boolean = false;
  errorCount : number = 0;
  eqmsScopes:number[] = []
  displayDataCollected : string[] = []
  trainingItemsDataToDisplay : any;
  userTrainingPlan : UserTrainingPlanDTO[] = [];
  feature:string = EmployeesTrainingPlanConstants.MyEmployee_TrainingPlan_Feature;
  trainingPlanDetails ?: TrainingPlanDetailsDto;
  @ViewChild(CourseCatalogueSearchComponent)
  private courseSearch!: CourseCatalogueSearchComponent;

  constructor(private messageService : MessageService,
    private eqmsScopeManagementService: EqmsScopeManagementService,
    private employeesTrainingPlanPersistenceService: EmployeesTrainingPlanPersistenceService,
    private employeesTrainingPlanService : EmployeesTrainingPlanService){
    this.items = [
      {
          label: 'Add',
          command: this.add
      }
    ]
  }

  ngOnInit(): void {
    this.employeesTrainingPlanPersistenceService.TrainingPlanSaveInProgress$.
        subscribe((trainingPlanSaveStatus) => {
          this.isTrainingPlanSaveInProgress = trainingPlanSaveStatus;
        });
      this.employeesTrainingPlanPersistenceService.closeAndResetTrainingPlanSlider$.subscribe((isClose) => {
        if (isClose) { this.closeAndResetEmployeeTrainingPlanSlider(); }
      })
  }

  onSelectionOrDeselection = (courses: CourseCatalogueSearchResult[]) => {

    let selectedCoursesList: string[] = [];
    courses.forEach(element => {
      selectedCoursesList.push(element.courseNumber);
    });
    this.displayDataCollected=[]
    this.displayDataCollected = selectedCoursesList;
    this.selectedCourses = [];
    this.selectedCourses = cloneDeep(courses);
  }

  addTrainingPlanAndClose(){
    this.addAndClose = true;
    this.getLinkedItems(this.addAndClose)
  }

  add = () => {
    this.addAndClose = false;
    this.getLinkedItems(this.addAndClose);
  };

  closeAndResetEmployeeTrainingPlanSlider(){
    this.selectedCourses = [];
    this.displayDataCollected = [];
    this.courseCatalogueSearchResult = [];
    this.showAddButton = false;
  }

  showOrHideAddButton = (displayAddBtn: boolean) => {
    this.showAddButton = displayAddBtn;
  }

  getLinkedItems(addAndClose:boolean)
  {
    this.eqmsScopes=[]
    const courseData = Object.assign([], this.selectedCourses);
    this.selectedCourses = courseData.map((course:any) => ({
      number: course.courseNumber,
      title: course.name,
      ...course, 
    }));
    this.errorCount=0;
    this.scope = this.userScopes?.eQMSPrimaryScope;
    
    // Directly validate and proceed without fetching existing training plan
    this.validateAndCreateOrUpdateTrainingPlan(addAndClose);
  }

  validateAndCreateOrUpdateTrainingPlan(addAndClose:boolean){
    // Only validate that at least one item is selected
    if(this.selectedCourses.length<=0)
    {
      this.validateToSelectAtleastOneTrainingItem();
      return;
    }
    
    // Proceed to validate scopes
    this.getParentAndDescendantsScopesAndCompare(this.selectedCourses, addAndClose); 
  }

  addTrainingPlan(matchingCourses: any[], addAndClose : boolean){
      this.employeesTrainingPlanPersistenceService.prepareDataForCourseTrainingItem(matchingCourses, this.userPUID);
      this.employeesTrainingPlanPersistenceService.addTrainingPlan(addAndClose);
  }

  validateToSelectAtleastOneTrainingItem(){
    this.errorCount = 0;
    this.messageService.add({
      severity: EmployeesTrainingPlanConstants.Severity_Err,
      summary: `${EmployeesTrainingPlanConstants.AtleastOneTrainingItem_ShouldBeSelected}`,
      life: 20000
    });
    this.errorCount++; 
  }




    //since scopes are not matching, we are trying to get its parent scopes and descendant scope compare with selected form scopes
    getParentAndDescendantsScopesAndCompare(serviceData: any[], addAndClose: boolean) {
      const scopes: number[] = [];

      // For ancestors Scopes
      this.userScopes?.ancestors?.forEach((ele : number) => {
        scopes.push(ele);
      }); 

      //For descendants Scopes
      this.userScopes?.descendants?.forEach((ele : number) => {
        scopes.push(ele);
      });
    
      const matchingCourses: any[] = [];
      const mismatchedCourses: any[] = [];
      
      serviceData.forEach((data) => {
        const { eqmsScopes } = data;    
        const hasMatch = eqmsScopes.some((scope: number) => scopes.includes(scope));    
        if (hasMatch) {
          matchingCourses.push(data);
        } else {
          mismatchedCourses.push(data);
        }
      });
      if (mismatchedCourses.length) {
        this.displayScopeValidationMessage(mismatchedCourses);
      }
      if (matchingCourses.length) {
        this.selectedItems(matchingCourses);
        // Always call addTrainingPlan (backend will handle duplicates)
        this.addTrainingPlan(matchingCourses, addAndClose);
      }
    }

    selectedItems(serviceData : any[]){
      if (!this.trainingItemsDataToDisplay || this.trainingItemsDataToDisplay.length === 0) {
        this.trainingItemsDataToDisplay = serviceData;
      } else {
        this.trainingItemsDataToDisplay.push(...serviceData);
      }
    }

    displayScopeValidationMessage(mismatchedCourses: any[]) {
      this.errorCount = 0;
      const courseNumbersString = mismatchedCourses.map((course) => `  ${course.courseNumber}`).join(', ');
      const validationMessage = EmployeesTrainingPlanConstants.Selected_CourseScopes_Not_Matching_Error_Message.replace(
        'CourseNumbers',
        `\n${courseNumbersString}`
      );
      this.messageService.add({
        severity: EmployeesTrainingPlanConstants.Severity_Err,
        summary: `${validationMessage}`,
        life: 20000
      });
      this.errorCount++; 
    }

}
